export const ops = {
  base: [
    { label: '等于（精确）', value: 'equal' },
    { label: '不等于', value: 'noEqual' },
    { label: '是空的', value: 'isEmpty' },
    { label: '不是空的', value: 'isNotEmpty' },
    { label: '是 null', value: 'isNull' },
    { label: '不是 null', value: 'isNotNull' },
    { label: `是 null 或者 ''`, value: 'isNullOrEmpty' },
    { label: `在 ... 中`, value: 'in' },
    { label: `不在 ... 中`, value: 'notIn' },
  ],
  text: [
    { label: '模糊包含', value: 'like' },
    { label: '模糊不包含', value: 'notLike' },
    { label: '左模糊', value: 'likeLeft' },
    { label: '右模糊', value: 'likeRight' },
  ],
  compare: [
    { label: '小于', value: 'lessThan' },
    { label: '小于等于', value: 'lessThanOrEqual' },
    { label: '大于', value: 'greaterThan' },
    { label: '大于等于', value: 'greaterThanOrEqual' },
    { label: '介于', value: 'between' },
    { label: '不介于', value: 'notBetween' },
  ],
}

// 数据类型对应条件符
export const typeMapOperator = {
  string: [...ops.base, ...ops.text],
  text: [...ops.base, ...ops.text],
  integer: [...ops.base, ...ops.compare],
  float: [...ops.base, ...ops.compare],
  datetime: [...ops.base, ...ops.compare],
  date: [...ops.base, ...ops.compare],
  time: [...ops.base, ...ops.compare],
}
